import { appFormUtil } from 'modules/common';
import React from 'react';
import * as types from './types';
import _ from 'lodash';
import {
  SiteUser_RegisterInput,
  useRegisterMutation
} from 'generated/graphql';
type IFormState = types.IRegisterUserFormState;

const STORAGE_KEY = 'attempts';

function __getPreferredEmail() {
  const numAttempts = _.toNumber(localStorage.getItem(STORAGE_KEY) ?? '2');
  const __mockEmail = process.env.REACT_APP_MOCK_EMAIL ?? '';
  const [
    first,
    second
  ] = __mockEmail.split('@');

  const preferredEmail = process.env.REACT_APP_MOCK_EMAIL ? `${first}${numAttempts}@${second}` : '';
  return preferredEmail;
}

const initialState: IFormState = {
  errorMessage: '',
  authState: 'NOT_STARTED',
  firstName: '',
  lastName: '',
  phone: '',
  activeStep: 1,
  inviteCode: '',
  password: process.env.REACT_APP_MOCK_PASSWORD ?? '',
  confirmPassword: process.env.REACT_APP_MOCK_PASSWORD ?? '',
  preferredEmail: __getPreferredEmail(),
  confirmationCode: ''
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      firstName: {
        label: 'First Name',
        type: 'text',
        required: true
      },
      lastName: {
        label: 'Last Name',
        type: 'text',
        required: true
      },
      inviteCode: {
        label: 'inviteCode',
        type: 'text'
      },
      phone: {
        label: 'Mobile Phone',
        type: 'tel',
        fnValidate: (v) => {
          if (typeof v !== 'string') {
            return '';
          }
          if (v.length < 6) {
            return '';
          }
          if (v.replaceAll(/\D/g, '').length !== 10) {
            return 'Please enter your full phone';
          }

          return '';
        }
      },
      preferredEmail: {
        label: 'Email',
        type: 'email',
        required: true
      },
      errorMessage: {
        label: 'message',
        type: 'text'
      },
      activeStep: {
        label: '',
        type: 'text'
      },
      authState: {
        label: '',
        type: 'text'
      },
      password: {
        label: 'Password',
        type: 'password',
        required: true
      },
      confirmPassword: {
        label: 'Confirm Password',
        type: 'password',
        required: true,
        fnValidate: (v) => {
          if (typeof v !== 'string') {
            return '';
          }

          if (formState.confirmPassword !== formState.password) {
            return 'Passwords do not match';
          }
          return '';
        }
      },

      confirmationCode: {
        label: 'Verification Code',
        type: 'text',
        required: true,
        fnValidate: (v) => {

          if (typeof v !== 'string') {
            return '';
          }

          return '';

        }
      }
    }
  });

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}


export function useRegisterUser() {
  const [
    fnMutate,
    tuple
  ] = useRegisterMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SiteUser_RegisterInput) => {
      await fnMutate({
        variables: {
          input: {
            ...input
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
